function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.6147 11.7005C12.6151 12.1093 12.9515 12.4406 13.3667 12.441V12.4403C13.7826 12.4403 14.1195 12.1085 14.1195 11.699L14.1202 10.2164C14.1202 9.80699 13.7832 9.4751 13.3675 9.4751C12.9517 9.4751 12.6147 9.80699 12.6147 10.2164V11.7005ZM12.614 13.9236C12.614 14.3331 12.951 14.6649 13.3668 14.6649C13.7825 14.6649 14.1196 14.3331 14.1196 13.9236C14.1196 13.5142 13.7825 13.1823 13.3668 13.1823C12.951 13.1823 12.614 13.5142 12.614 13.9236Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.56568 9.7252C0.598212 6.16964 2.74092 2.51496 6.35154 1.56226C9.96216 0.609546 13.6734 2.71957 14.6409 6.27513C14.7484 6.67019 14.5103 7.07627 14.1091 7.18212C13.708 7.28798 13.2956 7.05353 13.1881 6.65847C12.4356 3.89304 9.54908 2.25191 6.74082 2.9929C3.93255 3.7339 2.26601 6.57642 3.01848 9.34186C3.77095 12.1073 6.65749 13.7484 9.46576 13.0074C9.86694 12.9016 10.2793 13.136 10.3868 13.5311C10.4943 13.9261 10.2562 14.3322 9.85503 14.4381C6.24441 15.3908 2.53314 13.2808 1.56568 9.7252Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.10334 5.03809C8.48901 5.03809 8.80687 5.32397 8.85031 5.69228L8.85537 5.77864V7.69298L10.8912 9.69833C11.1623 9.96529 11.1831 10.3854 10.9537 10.6759L10.8912 10.7456C10.6201 11.0126 10.1935 11.0331 9.89851 10.8072L9.82766 10.7456L7.57158 8.52397C7.45405 8.40823 7.37945 8.25814 7.35784 8.09766L7.35132 8.00031V5.77864C7.35132 5.36964 7.68801 5.03809 8.10334 5.03809Z",
  fill: "currentColor"
});

function SvgExchangePendent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangePendent);
export default __webpack_public_path__ + "static/media/exchange-pendent.964785fd.svg";
export { ForwardRef as ReactComponent };